<script setup lang="ts">
import { useLang } from '@/composables/use-lang'
import ToggleContent from '@/lang/toggle.json'

const props = defineProps({
  isVisible: Boolean,
  offLabel: String,
  onLabel: String
})
const model = defineModel()
const langContent = useLang(ToggleContent)
const onLabel = props.onLabel || langContent.on
const offLabel = props.offLabel || langContent.off
</script>

<template>
  <label class="cursor-pointer border border-red w-24 rounded-lg overflow-hidden">
    <input class="absolute opacity-0" v-bind="$attrs" type="checkbox" v-model="model" />
    <div :class="`flex ${isVisible ? 'justify-end' : 'justify-start'}`">
      <span
        :class="`w-20 text-white ${isVisible ? 'bg-sweet-brown rounded-l-lg' : 'bg-green rounded-r-lg'}`"
        >{{ isVisible ? offLabel : onLabel  }}</span
      >
    </div>
  </label>
</template>

<style></style>
